<template>
  <!--链接体-->
  <mobileShipLink
      v-for="(item, index) in shipList"
      :key="item"
      :item="item"
      :index="index"
      class="animate__animated animate__fadeInDown"
  ></mobileShipLink>
</template>

<script>
//友情链接
import mobileShipLink from "./mobileShipLink";
//封装好的axios
import {getRequest} from '@/utils/service'
import {baseUrl} from '@/utils/request'
import {ElMessage} from "element-plus";
//正则
import {validateURL, validateMail, validateSpace} from '@/utils/rule'

export default {
  name: "shipList",
  components: {mobileShipLink},
  data() {
    return {
      baseUrl: '',
      //子组建数组
      shipList: [],
      //弹出框
      applyDialog: false,
      //名称
      shipName: '',
      //简介
      shipInfo: '',
      //链接
      shipUrl: '',
      //图标
      shipIcon: '',
      //邮箱
      shipMail: ''
    }
  },
  props: {},
  created() {
    this.baseUrl = baseUrl();
    //加载朋友列表
    this.loadShipList();
  },
  methods: {
    loadShipList() {
      //判断页码
      let page = 1;
      let total = this.shipList.length;
      if (total > 10) {
        page = total / 10;
      }

      //查询后台数据
      getRequest(this.baseUrl + '/ship/getShip?page=' + page + '&limit=10')
          .then((res) => {
            let data = res.data.data;

            this.shipList = data;
          })
          .catch(function (error) {
            ElMessage.error(error)
          })
    },
  }
}
</script>

<style scoped>

</style>